export default __webpack_public_path__ + "static/media/IFeelSick_15.745d71d2.png";